// Hilfsfunktion: sanftes Scrollen zu einem Abschnitt der durchgehenden Seite.
export function scrollToSection(id) {
  if (typeof document === "undefined") return;
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

export const SECTION_IDS = ["start", "leistungen", "branchen", "ueber", "kontakt"];
